import { ShoppingCart } from "react-feather";
import styled from "styled-components";
import { COLOR_RED, COLOR_WHITE, COLOR_YELLOW } from "../constants/colors";
import { useAppContext } from "../contexts/App";

const Container = styled.a`
  position: fixed;
  z-index: 5;
  background-color: ${COLOR_WHITE};
  right: 60px;
  bottom: 60px;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.3);

  @media only screen and (max-width: 768px) {
    right: 20px;
    bottom: 20px;
    width: 60px;
    height: 60px;
  }

  @media only screen and (max-width: 576px) {
    right: 20px;
    bottom: 20px;
  }
`;

const CartWrapper = styled.div`
  position: relative;
  margin-left: -3px;
`;

const Badge = styled.div`
  position: absolute;
  background-color: ${COLOR_RED};
  color: ${COLOR_WHITE};
  font-size: 12px;
  font-family: "Libre Franklin", sans-serif;
  font-weight: 600;
  top: -6px;
  right: -8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const IcShoppingCart = styled(ShoppingCart)`
  width: 40px;
  height: 40px;
  color: ${COLOR_YELLOW};

  @media only screen and (max-width: 768px) {
    width: 30px;
    height: 30px;
  }
`;

function FloatingCart() {
  const appContext = useAppContext();
  return (
    <Container href="/cart">
      <CartWrapper>
        {!!appContext?.cartItemCount && <Badge>{appContext.cartItemCount > 99 ? 99 : appContext.cartItemCount}</Badge>}
        <IcShoppingCart />
      </CartWrapper>
    </Container>
  );
}

export default FloatingCart;
